"use client";
import { Avatar, DropdownMenu, Flex, Text } from "@radix-ui/themes";
import { DarkModeToggler } from "@/components/DarkModeToggler";
import { ChevronDownIcon } from "lucide-react";
import { useUser } from "@/hooks/useUser";
import LogoutButton from "./LogoutButton";
import { LivechatToggler } from "./LivechatToggler";

export function UserContainer() {
  var user = useUser()?.user;

  return (
    <>
      <Flex align={"center"} gap={"3"}>
        <LivechatToggler />
        <DarkModeToggler />
        {user?.firstName && (
          <Flex gap="2" align={"center"}>
            <div className="md:block hidden">
              <Flex gap="1" className="text-[12px]">
                <Text>{user && user?.firstName}</Text>
                <Text>{user && user?.lastName}</Text>
              </Flex>
            </div>
            <DropdownMenu.Root>
              <DropdownMenu.Trigger>
                <div className="flex items-center gap-2 px-2 py-1 bg-primary-200 rounded-xl">
                  <Avatar
                    fallback={user?.firstName?.at(0)}
                    size={"2"}
                    radius={"full"}
                  />
                  <ChevronDownIcon />
                </div>
              </DropdownMenu.Trigger>
              <DropdownMenu.Content>
                <LogoutButton />
              </DropdownMenu.Content>
            </DropdownMenu.Root>
          </Flex>
        )}
      </Flex>
    </>
  );
}
